<template>
  <div class="w-full flex">

    <!-- Preview for form editor -->
    <div v-if="productData == null" class="w-full flex gap-1 items-center">
      <input :disabled="true" type="checkbox" class="cursor-grab outline-0 border border-bg-trader-input-border border-header p-1 my-1" >
    </div>

    <!-- Fieldtype -->
    <div v-else class="w-full flex gap-1 items-center">
      <input :disabled="true" type="checkbox" class="outline-0 border border-bg-trader-input-border border-header p-1 my-1 w-4 h-4" :value="active" :checked="active">
    </div>

  </div>
</template>

<script>
export default {
  props: {
    name: "Price MwSt Checkbox",
    formField: {
      type: Object,
      default: () => {
      }
    },
    productData: {
      type: Object,
      default: () => {
      }
    },
    onChangeProductFieldValue: {
      type: Function,
      default: () => {}
    },
    getFieldValue: {
      type: Function,
      default: () => {
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
    active() {
      return this.productData.customFields['price'].value !== '' && this.productData.customFields['vat'].value !== '';
    }
  },
  methods: {
  }
}
</script>


